/**
 * VERA-291 — single source of truth for the SMS (A2P 10DLC) consent copy.
 *
 * This text is rendered in TWO places and MUST stay byte-identical between
 * them. If they drift, a carrier reviewer comparing the two sees an
 * inconsistency — the same failure class that got our first A2P 10DLC
 * campaign rejected (2026-08-03) for "opt-in flow doesn't contain compliant
 * consent agreement language": the language existed, the reviewer just
 * couldn't reach it (enrollment is behind sign-in).
 *
 *   1. `components/UI/PhoneVerificationDrawer.tsx` — the real consent
 *      checkbox label (renders `SMS_CONSENT_TEXT` directly).
 *   2. `public/sms.html` — the public page carrier reviewers can reach
 *      without an account. It is GENERATED from this file by
 *      `scripts/gen-sms-html.mjs` (`pnpm run gen:sms-html`) and stays
 *      committed so it's servable without a build step. CI regenerates it
 *      and fails if the committed file differs — see
 *      `.github/workflows/deploy.yml`.
 *
 * Do NOT change SMS_CONSENT_TEXT's wording without updating the Twilio A2P
 * campaign submission — it is the exact string under review. The specific
 * phrases ("Message frequency varies", "Consent is not a condition of
 * purchase") are what a reviewer pattern-matches against the CTIA checklist;
 * substantively-equivalent rewording has previously read as non-compliant.
 */
export const SMS_CONSENT_TEXT =
  'Yes, text me at this number. I agree to receive automated text messages from Vera: ' +
  'verification codes, scan alerts, and ownership transfer updates. Message frequency ' +
  'varies. Message and data rates may apply. Reply STOP to cancel or HELP for help. ' +
  'Consent is not a condition of purchase.'

/**
 * Consent line for the SECOND program on the same campaign: sign-in security codes for staff
 * and account holders on the Vera platform (apps/platform → Settings → Security → "Add phone
 * number"). Shown beside the phone field, so adding a number is the agreement.
 *
 * Rendered verbatim in:
 *   1. `apps/platform/src/pages/settings/SecurityPage/components/EnrollSmsModal.tsx`, via
 *      `apps/platform/src/constants/smsConsent.ts` (a separate app cannot import this file at
 *      runtime; `apps/platform/test/sms-security-consent.guard.spec.ts` fails if the two copies
 *      differ by a single character).
 *   2. `public/sms.html`, generated from this file like SMS_CONSENT_TEXT above.
 */
export const SECURITY_SMS_CONSENT_TEXT =
  'By adding your number you agree to receive security codes by text. ' +
  'Message and data rates may apply. Reply STOP to opt out.'

export const TERMS_URL = 'https://vera.inc/terms-and-conditions'
export const PRIVACY_URL = 'https://vera.inc/privacy-policy'
